import React, { useContext, useState } from "react"
import { NavLink } from "react-router-dom"

import Constants from "../../config.js"
import { Loader } from "../../components/Loader"
import { getLog } from "../../helpers/helpers"
import { UserContext } from "../../Contexts/UserContext/UserContext"
import { ButtonPrimary, ButtonPrimaryOutlined } from "../../components/Buttons.js"



export default function EnterWalletName(props) {
    const userContext = useContext(UserContext)
    const classname = "EnterWalletName: "

    const function_id = classname + "render(): "
    const log = getLog(function_id)

    const [readyToContinue, set_readyToContinue] = useState(false)

    if (!readyToContinue && userContext.walletname.length > 0) {
        set_readyToContinue(true)
    }

    const onChange_walletname = (event) => {
        const new_name = event.target.value
        userContext.update_wallet_name(new_name)

        if (new_name.length > 1) {
            set_readyToContinue(true)
        }
    }

    var returnbuttonjsx = ""
    var previous_mode = userContext.get_newpassword_previous()
    if (previous_mode == "restore_from_seed") {
        returnbuttonjsx =
            <NavLink className="return-logo" to="/restore_wallet">
                <ButtonPrimaryOutlined>
                    Back
                </ButtonPrimaryOutlined>
            </NavLink>
    } else {  // if (previous_mode == "create_new_wallet") {
        returnbuttonjsx =
            <NavLink className="return-logo" to="/create_new_wallet">
                <ButtonPrimaryOutlined>
                    Back
                </ButtonPrimaryOutlined>
            </NavLink>
    }

    // this style is used to deactivate some buttons while generating the seed
    var continueButton_style = {}
    if (!readyToContinue) {
        continueButton_style = {
            pointerEvents: "none",
            backgroundColor: "gray",
        }
    }

    return (
        <div className="mode-selection-style">

            <h2>
                <br />
                {/* {Constants.PASSWORD_TITLE} */}
                Give a name to Your wallet
            </h2>
            <br /><br />

            <form name="message" method="post">
                <section>
                    <div className="input_style" >
                        <div className="field_name">
                            <input onChange={onChange_walletname}
                                value={userContext.walletname}
                                id="walletname" type="text" name="wallet_name"
                                className="text_spacing"
                                placeholder={Constants.ENTER_WALLET_NAME}
                                style={{ padding: "0.5em", width: "20em" }} />
                        </div>
                        <br />
                    </div>
                </section>
            </form>
            <div style={{ height: "20vh" }}>&nbsp;</div>

            {/* Buttons */}

            <div className="bottom-buttons">
                <div className="return-button">
                    {returnbuttonjsx}
                </div>
                <div className="next-button">
                    <NavLink className="return-logo" to={readyToContinue ? "/wallet_password" : "#"}>
                        <ButtonPrimary style={continueButton_style}>
                            Continue &nbsp; {readyToContinue ? "" : <Loader small />}
                        </ButtonPrimary>
                    </NavLink>
                </div>
            </div>

            {/* make it easier to scroll if needed */}
            <div style={{ height: "40vh" }}>&nbsp;</div>

        </div>
    )
}
